<template>
  <v-container fluid>
    <main-header-plat-a />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-row class="flex-nowrap">
      <div class="barLateral">
        <v-nav-draw-anam
          :schemaNavIdent="schema.schemaIdent"
          :dialogAccountPin="schema.dialogAccountPin"
          :anamIndex="anamIndex"
          :anamGroupShow="anamGroupShow"
        />
      </div>
      <div class="contentCentral">
        <v-card-form-anam :anamRoute="schema.anamRoute" />
        <v-card width="1200" min-height="445" class="grey lighten-3 mt-14" flat>
          <v-row justify="center" class="mt-3 mb-8" wrap>
            <div class="ml-1">
              <v-col
                v-for="(anamI1, i1) in anamGroupShow.anamGroupI"
                :key="'groupI-' + i1"
                class="secundary--text text-body-2 ml-3 py-0 my-2"
              >
                <router-link
                  class="secundary--text"
                  :to="anamI1.to"
                  style="text-decoration: none; color: inherit"
                >
                  {{ anamI1.title }}
                  <v-icon small v-if="anamI1.permission === false">mdi-lock-alert</v-icon>
                </router-link>

                <div
                  v-for="(anamI1Sub1, i2) in anamI1.subtitle"
                  :key="'groupI-' + i1 + '-sub1-' + i2"
                  class="secundary--text ml-6 my-1 mt-3"
                >
                  <router-link
                    class="secundary--text"
                    :to="anamI1Sub1.to"
                    style="text-decoration: none; color: inherit"
                  >
                    {{ anamI1Sub1.title }}
                    <v-icon small v-if="anamI1Sub1.permission === false">mdi-lock-alert</v-icon>
                  </router-link>

                  <div
                    v-for="(anamI1Sub1Sub, i3) in anamI1Sub1.subtitle"
                    :key="'groupI-' + i1 + '-sub1-' + i2 + '-sub2-' + i3"
                    class="secundary--text ml-5 my-1"
                  >
                    <router-link
                      class="secundary--text"
                      :to="anamI1Sub1Sub.to"
                      style="text-decoration: none; color: inherit"
                    >
                      {{ anamI1Sub1Sub.title }}
                      <v-icon small v-if="anamI1Sub1Sub.permission === false"
                        >mdi-lock-alert</v-icon
                      >
                    </router-link>
                  </div>
                </div>
              </v-col>
            </div>

            <v-divider vertical class="ml-13"></v-divider>

            <div>
              <v-col
                v-for="(anamII1, i1) in anamGroupShow.anamGroupII"
                :key="'groupII-' + i1"
                class="secundary--text text-body-2 ml-3 py-0 my-2 mb-8"
              >
                <router-link
                  class="secundary--text"
                  :to="anamII1.to"
                  style="text-decoration: none; color: inherit"
                >
                  {{ anamII1.title }}
                  <v-icon small v-if="anamII1.permission === false">mdi-lock-alert</v-icon>
                </router-link>

                <div
                  v-for="(anamII1Sub1, i2) in anamII1.subtitle"
                  :key="'groupII-' + i1 + '-sub1-' + i2"
                  class="secundary--text ml-6 my-1 mt-3"
                >
                  <router-link
                    class="secundary--text"
                    :to="anamII1Sub1.to"
                    style="text-decoration: none; color: inherit"
                  >
                    {{ anamII1Sub1.title }}
                    <v-icon small v-if="anamII1Sub1.permission === false">mdi-lock-alert</v-icon>
                  </router-link>

                  <div
                    v-for="(anamII1Sub1Sub, i3) in anamII1Sub1.subtitle"
                    :key="'groupII-' + i1 + '-sub1-' + i2 + '-sub2-' + i3"
                    class="secundary--text ml-5 my-1"
                  >
                    <router-link
                      class="secundary--text"
                      :to="anamII1Sub1Sub.to"
                      style="text-decoration: none; color: inherit"
                    >
                      {{ anamII1Sub1Sub.title }}
                      <v-icon small v-if="anamII1Sub1Sub.permission === false"
                        >mdi-lock-alert</v-icon
                      >
                    </router-link>
                  </div>
                </div>
              </v-col>

              <v-col
                v-for="(anamIII1, i1) in anamGroupShow.anamGroupIII"
                :key="'groupIII-' + i1"
                class="secundary--text text-body-2 ml-sm-4 ml-lg-8 pt-2"
              >
                <router-link
                  class="secundary--text"
                  :to="anamIII1.to"
                  style="text-decoration: none; color: inherit"
                >
                  {{ anamIII1.title }}
                  <v-icon small v-if="anamIII1.permission === false">mdi-lock-alert</v-icon>
                </router-link>

                <div
                  v-for="(anamIII1Sub1, i2) in anamIII1.subtitle"
                  :key="'groupIII-' + i1 + '-sub1-' + i2"
                  class="secundary--text ml-6 py-0 my-4"
                >
                  <router-link
                    class="secundary--text"
                    :to="anamIII1Sub1.to"
                    style="text-decoration: none; color: inherit"
                  >
                    {{ anamIII1Sub1.title }}
                    <v-icon small v-if="anamIII1Sub1.permission === false">mdi-lock-alert</v-icon>
                  </router-link>

                  <div
                    v-for="(anamIII1Sub2, i3) in anamIII1Sub1.subtitle2"
                    :key="'groupIII-' + i1 + '-sub1-' + i2 + '-sub2-' + i3"
                    class="secundary--text ml-6 my-1"
                  >
                    <router-link
                      class="secundary--text"
                      :to="anamIII1Sub2.to"
                      style="text-decoration: none; color: inherit"
                    >
                      {{ anamIII1Sub2.title }}
                      <v-icon small v-if="anamIII1Sub2.permission === false">mdi-lock-alert</v-icon>
                    </router-link>
                  </div>
                </div>
              </v-col>
            </div>
          </v-row>
        </v-card>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VNavDrawAnam from '@/components/base/VNavDrawAnam.vue';
import VCardFormAnam from '@/components/base/VCardFormAnam.vue';

export default {
  name: 'ProPatientsCAnamnesisPage',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
    VNavDrawAnam,
    VCardFormAnam,
  },
  data() {
    return {};
  },
  mounted() {
    this.loadSchema();
    this.loadPermissionsHCP();
  },
  computed: {
    ...mapGetters('proPatientsCAnamnesisPage', ['schema']),
    ...mapGetters('anamPermissions', ['anamIndex', 'anamGroupShow']),
  },
  methods: {
    ...mapActions('proPatientsCAnamnesisPage', ['loadSchema']),
    ...mapActions('anamPermissions', ['loadPermissionsHCP']),

    insertRoute(ruta) {
      this.$router.push(ruta);
      this.$route.query;
    },
  },
};
</script>

<style>
.barLateral {
  min-width: 60px;
}

.contentCentral {
  width: 96%;
}

.contentCardCentral {
  width: 98.5%;
  margin-top: 84px;
}
</style>
